<template>
  <button class="rounded-sm" :class="classes" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    btnStyle: {
      type: String,
      default: "green",
    },
  },
  computed: {
    classes() {
      return this.mapStyleToClass[this.btnStyle]
    },
    mapStyleToClass() {
      return {
        // Add more as needed
        green: "btn-green",
        blue: "btn-blue",
        "blue-bordered": "btn-blue-bordered",
        link: "btn-link",
        transparent: "btn-transparent",
        "red-bordered": "btn-red-bordered",
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-green {
  border-radius: 0.25rem;
  color: #fff;
  background: #1acd62;
}

.btn-green:hover,
.btn-green:active,
.btn-green:focus {
  background: #16ad53;
}

.btn-blue {
  border-radius: 0.25rem;
  color: #fff;
  background: #1e6acc;
}

.btn-blue:hover,
.btn-blue:active,
.btn-blue:focus {
  background: #1959ad;
}

.btn-blue-bordered {
  border: 1px solid #1e6acc;
  border-radius: 0.25rem;
  color: #1e6acc;
}

.btn-blue-bordered:hover,
.btn-blue-bordered:active,
.btn-blue-bordered:focus {
  color: #fff;
  background: #1e6acc;
}

.btn-link {
  color: #1e6acc;
}

.btn-link:hover,
.btn-blue:active,
.btn-blue:focus {
  text-decoration: underline;
}

.btn-transparent:hover,
.btn-transparent:active,
.btn-transparent:focus {
  background: #f1f1f1;
}

.btn-red-bordered {
  @apply border border-red text-red;
}

.btn-red-bordered:hover,
.btn-red-bordered:active,
.btn-red-bordered:focus {
  @apply bg-red text-white;
}
</style>
